import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from "react-table";
import _ from 'lodash';
import { CSVLink } from 'react-csv';
import { sanitizeCsvData } from '../../../utils/csvSanitizer';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import DATA_MINING_CONTROLLER from '../../../controllers/dataMining';
import Logger, { LOG_LEVELS } from '../../../utils/log';
import { TableConfig } from '../../../utils/appConfig';
import NoData from '../../page/NoData';
import Pagination from '../../page/Pagination'
import SIILogLinesColumns from "../reportDefinition/SIILog.json";

const log = new Logger('DATA_MINING_SIILOG_LINES_PAGE', LOG_LEVELS.DEBUG);
const SIILogColumnMapping = {
    "nr": "Nr", 
    "id": "Id",
    "dateTimeStamp":"Date",
    "message":"Message"
};
const DEFAULT_PAGINATION_CONFIG = {
    pageNumber: 1,
    pageSize: TableConfig.STANDARD_LEVEL_ONE_PAGE_SIZE,
    page:0,
    startAt: 1
};

export class SIILogPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selection: {
                reportType: 'SII log'
            },
            filterCriteria: props.filterCriteria,
            pagination: DEFAULT_PAGINATION_CONFIG,
            loading: true
        };
        this.onFetchDataHandler = this.onFetchDataHandler.bind(this);
    }

    getParameters(selection, pagination) {
        let params = {
            startAt: pagination.startAt,
            pageSize: pagination.pageSize,
            startDate: selection.startDate,
            endDate: selection.endDate,
            sortAscending: selection.sortAscending
        };
        return params;
    }
    getColumns() {
        var columnData = SIILogLinesColumns;

        log.debug('render(): columnData', columnData);

        const columns = columnData.map((item, id) => {
            log.debug('render(): item', item, item.Accessor, item.Header);
            return {
                id: item.Accessor,
                Header: props => <LanguageStringResolver string={item.Header} />,
                accessor: item.Accessor,
                style: item.textAlign !== undefined ? { textAlign: "right" } : "",
                minWidth: item.MinWidth !== undefined ? item.MinWidth : 200,
            }
        })
        log.debug('render(): ', columns);
        return columns;
    }

    onFetchDataHandler(state) {
        log.debug('onFetchDataHandler(): ');
        let { page, pageSize } = state;
        pageSize = Object.is(pageSize, NaN) ? TableConfig.STANDARD_LEVEL_ONE_PAGE_SIZE : pageSize;
        page = Object.is(page, NaN) ? 0 : page;
        const startAt = page * pageSize;
        let pagination = Object.assign({}, this.state.pagination, {
            pageNumber: page + 1,
            page: page,
            pageSize: pageSize,
            startAt: startAt + 1
        });
        //To set default/hidden properties of react table
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page = 0;
        }
        this.setState({
            pagination: pagination,
            viewTableState: state,
            loading: true
        });

        this.props.getSIILog(this.getParameters(this.props.filterCriteria, pagination), () => {
            let pagination = Object.assign({}, this.state.pagination);           
            let siiLogs = (this.props.siiLogData && this.props.siiLogData.siiLogs) || [];
            let totalCount = (this.props.siiLogData && this.props.siiLogData.totalCount) || siiLogs.length;
            pagination.pages = pagination.pageSize === 0 ? totalCount : Math.ceil(totalCount / pagination.pageSize);
            this.setState({
                loading: false,
                pagination: pagination
            });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        //when reportType is same and filters are updated/changed and clicked apply, need to call fetch data explicitely
        if ((nextProps.filterCriteria.startDate !== this.props.filterCriteria.startDate) ||
            (nextProps.filterCriteria.reportType !== this.props.filterCriteria.reportType) ||
            (nextProps.filterCriteria.endDate !== this.props.filterCriteria.endDate) ||
            (nextProps.filterCriteria.sortAscending !== this.props.filterCriteria.sortAscending)
            ) 
        {
            this.props = nextProps;
            this.onFetchDataHandler(Object.assign({}, DEFAULT_PAGINATION_CONFIG, {pageSize: this.state.pagination.pageSize}));
        }
    }

    render() {
        log.debug('render() - props: ', this.props);
        const columns = this.getColumns();
        let pagination = this.state.pagination || Object.assign({}, DEFAULT_PAGINATION_CONFIG);        
        if(this.viewTable && this.viewTable.state) {
            this.viewTable.state.page =pagination.page;
        }
        let siiLogs = (this.props.siiLogData && this.props.siiLogData.siiLogs) || [];
        let fileName = (this.state.selection && this.state.selection.reportType) ? this.state.selection.reportType.replace(' ', '') + '.csv' : "DataMining.csv"
        let siiLogsCsvData = siiLogs;
        for (var key in SIILogColumnMapping) {
            siiLogsCsvData = JSON.parse(JSON.stringify(siiLogsCsvData).split('"' + key + '":').join('"' + SIILogColumnMapping[key] + '":'));
        }
        const NoDataComponent = props => (
            <NoData
                noDataText="transactionReports_NoData"
                {...props}
            />
        )

        return (
            <div>
                <ReactTable
                    manual
                    pages={pagination.pages || 1}
                    defaultPageSize={TableConfig.PAGINATION.STANDARD_LEVEL_ONE_PAGE_SIZE}
                    pageSizeOptions={TableConfig.PAGINATION.STANDARD_PAGE_SIZE_OPTIONS}
                    minRows={0}
                    maxRows={0}
                    ref={ref => this.viewTable = ref}
                    data={siiLogs}
                    columns={columns}
                    loading={this.props.loading} // Display the loading overlay when we need it
                    onFetchData={this.onFetchDataHandler} // Request new data when things change
                    sortable={false}
                    showPageJump={true}
                    NoDataComponent={NoDataComponent}
                    className={_.isEmpty(siiLogs) ? 'mb30 hide-header' : 'mb30'}
                    PaginationComponent={Pagination}
                    showPagination={siiLogs.length === 0 ? false : true}
                />
                <CSVLink
                    data={sanitizeCsvData(siiLogsCsvData)}
                    filename={fileName}
                    className={siiLogsCsvData && siiLogsCsvData.length > 0 ? "button secondary" : "invisible"}>
                    <LanguageStringResolver string='dataMining_ExportToExcel' />
                </CSVLink>
            </div>
        );
    }
}


SIILogPage.defaultProps = {
    filterCriteria: {},
    isReportTypeChanged: false
}

function mapStateToProps(state) {
    return {
        languages: state.languages,
        siiLogData: (state.dataMining && state.dataMining.siiLogData)
    }
}

function mapDispatchersToProps(dispatch) {
    return {
        getSIILog :(params, callback) => {
            log.debug('getSIILog()');
            dispatch(DATA_MINING_CONTROLLER.getSIILog(params, callback));
        }
    }
}

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(SIILogPage);